export default "__VITE_ASSET__DW2qoY1V__"